import React from 'react';
import { WarningIcon } from 'components/Icon/Custom';
import { Space, VerticalSpace } from 'components/Space';
import { Title } from 'components/Typography/Title';
import { Text } from 'components/Typography';
import { spacing } from 'constants/spacing';
import { Link } from 'components/Typography/Link';
import { Button } from 'components/Button';
import { SAMOLET_PHONE, SAMOLET_PHONE_FORMATTED, commonProps } from '../constants';
import { IStatusChildrenProps } from '../types';
import { useStatusPageHandlers } from '../useStatusPageHandlers';
import { Wrapper } from './styled';

const InternalServerError: React.FC<IStatusChildrenProps> = ({
  isSaas,
  additionalDescription,
}) => {
  const { handleRefreshPage, handleRequestSupport } = useStatusPageHandlers();

  return (
    <Wrapper>
      <VerticalSpace size={20} {...commonProps}>
        <WarningIcon />

        <VerticalSpace size={spacing.md} {...commonProps}>
          <VerticalSpace size={spacing.sm} {...commonProps}>
            <VerticalSpace size={spacing.xxs} {...commonProps}>
              <Title level='h6'>Сервис недоступен</Title>

              <VerticalSpace size={0} {...commonProps}>
                <Text color='gray650'>
                  Мы уже устраняем неисправность. Попробуйте обновить
                </Text>
                <Text color='gray650'>страницу позже или обратитесь в поддержку</Text>
              </VerticalSpace>

              {additionalDescription && (
                <Text color='gray650'>{additionalDescription}</Text>
              )}
            </VerticalSpace>

            {!isSaas && (
              <VerticalSpace size={spacing.xxs} {...commonProps}>
                <Link href={`tel:${SAMOLET_PHONE}`}>{SAMOLET_PHONE_FORMATTED}</Link>
                <Text color='gray650'>График работы: с 9:00 до 21:00 без выходных</Text>
              </VerticalSpace>
            )}
          </VerticalSpace>

          <Space>
            <Button
              variant={isSaas ? 'secondary' : 'primary'}
              onClick={handleRefreshPage}
            >
              Обновить страницу
            </Button>
            {isSaas && (
              <Button variant='primary' onClick={handleRequestSupport}>
                Написать в поддержку
              </Button>
            )}
          </Space>
        </VerticalSpace>
      </VerticalSpace>
    </Wrapper>
  );
};

export default InternalServerError;
